import React from 'react'
import { Link } from 'gatsby'
import '../Side-bar/side-bar.css'
import Menu from '../Board-Menu/menu'
import { ThemeToggler } from 'gatsby-plugin-dark-mode'

const SideBar = obj => {
  let lang = obj.pathname
    ? obj.pathname.split('/')[1]
      ? obj.pathname.split('/')[1]
      : 'en-CA'
    : 'en-CA'

  return (
    <div className="sidebar-wrapper">
      <ThemeToggler>
        {({ theme, toggleTheme, isOn, handleToggle }) => (
          <>
            <input
              checked={theme === 'dark'}
              onChange={e => toggleTheme(e.target.checked ? 'dark' : 'light')}
              className="react-switch-checkbox"
              id={`react-switch-new`}
              type="checkbox"
            />
            Dark Mode
            <label
              style={{ background: isOn && onColor }}
              className="react-switch-label"
              htmlFor={`react-switch-new`}
            >
              <span className={`react-switch-button`}>
                <div className="sun_icon" />
              </span>
            </label>
          </>
        )}
      </ThemeToggler>
      <hr />
      <div className="community">
        <h5 className="text_upper">National Statistics</h5>
        <ul>
          <li>
            <Link
              activeStyle={{
                color: '#CF2126',
                textDecoration: 'underline dotted #000000CC',
                textUnderlinePosition: 'under',
                fontWeight: 'bold',
                textDecoration: 'var(--textDecor)',
              }}
              to={'/en-CA'}
            >
              National English
            </Link>
          </li>
          <li>
            <Link
              activeStyle={{
                color: '#CF2126',
                textDecoration: 'underline dotted #000000CC',
                textUnderlinePosition: 'under',
                fontWeight: 'bold',
                textDecoration: 'var(--textDecor)',
              }}
              to="/fr-CA"
            >
              National Fran&ccedil;ais
            </Link>
          </li>
        </ul>
        <br />
        <Menu />
        <br />
      </div>
      <h5 className="text_upper"> Housing Market Stats</h5>
      <ul>
        <li>
          <a href="http://www.crea.ca/housing-market-stats/mls-home-price-index/">
            MLS® Home Price Index
          </a>
        </li>
        <ul className="children">
          <li>
            <a href="http://www.crea.ca/housing-market-stats/mls-home-price-index/about-hpi/">
              About MLS® HPI
            </a>
          </li>
          <li>
            <a href="http://www.crea.ca/housing-market-stats/mls-home-price-index/getting-started/">
              How Does the MLS® HPI Help Me?
            </a>
          </li>
          <li>
            <a href="http://www.crea.ca/housing-market-stats/mls-home-price-index/hpi-tool/">
              Try the MLS® HPI Tool
            </a>
          </li>
          <li>
            <a href="http://www.crea.ca/housing-market-stats/mls-home-price-index/resources/">
              Reference Materials
            </a>
          </li>
        </ul>
      </ul>

      <ul>
        <h5 className="text_upper">National Statistics</h5>
        <ul className="children ntl_stats">
          <li>
            <Link
              activeStyle={{
                color: '#CF2126',
                textDecoration: 'underline dotted #000000CC',
                textUnderlinePosition: 'under',
                fontWeight: 'bold',
                textDecoration: 'var(--textDecor)',
              }}
              to="/en-CA/stats/2WzwJAqfKd3QekqmJcKmli/"
            >
              About
            </Link>
          </li>
          <li>
            <Link
              activeStyle={{
                color: '#CF2126',
                textDecoration: 'underline dotted #000000CC',
                textUnderlinePosition: 'under',
                fontWeight: 'bold',
                textDecoration: 'var(--textDecor)',
              }}
              to="/en-CA/stats/3Yj8RUXHGUebU2k1UfYnqT/"
            >
              Employment Trends
            </Link>
          </li>
          <li>
            <Link
              activeStyle={{
                color: '#CF2126',
                textDecoration: 'underline dotted #000000CC',
                textUnderlinePosition: 'under',
                fontWeight: 'bold',
                textDecoration: 'var(--textDecor)',
              }}
              to="/en-CA/stats/ZtDiHSNyWRJYz57YMk7aX/"
            >
              Interest Rate Changes
            </Link>
          </li>
          <li>
            <Link
              activeStyle={{
                color: '#CF2126',
                textDecoration: 'underline dotted #000000CC',
                textUnderlinePosition: 'under',
                fontWeight: 'bold',
                textDecoration: 'var(--textDecor)',
              }}
              to="/en-CA/stats/2k7dZil1MPa7B2vbqlNKlH/"
            >
              Consumer Confidence
            </Link>
          </li>
          <li>
            <Link
              activeStyle={{
                color: '#CF2126',
                textDecoration: 'underline dotted #000000CC',
                textUnderlinePosition: 'under',
                fontWeight: 'bold',
                textDecoration: 'var(--textDecor)',
              }}
              to="/en-CA/stats/7MELNRD8vrte7Qywn37pc4/"
            >
              Canada Migration
            </Link>
          </li>
        </ul>
      </ul>
      <ul>
        <li>
          <a href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/quarterly-forecasts/">
            Quarterly Forecasts
          </a>
        </li>
        <li>
          <a href="https://www.crea.ca/housing-market-stats/national-price-map/">
            National Price Map
          </a>
        </li>
      </ul>
      <br />
      <div className="widgets widget_1">
        <h2>Why A Realtor<sup>®</sup>?</h2>
        <p>
          Whether you're buying or selling, a real estate transaction can be
          complicated. A REALTOR® helps by making it easy for you...
          <a href="http://www.crea.ca/buyers-or-sellers/why-a-realtor/">
            Read more ›
          </a>
        </p>
      </div>
      <div className="widgets widget_2">
        <h2>How CREA Helps</h2>
        <p>
          CREA works to benefit Canadian homeowners, and through the efforts of
          our membership, give back to our communities...
          <a href="https://www.crea.ca/who-we-are/mission/">
            Read more ›
          </a>
        </p>
      </div>
      <div className="widgets widget_3">
        <h2>Get Info And Stats</h2>
        <p>
          With the accurate, up-to-date information that CREA provides, you'll
          know what's going on in the housing market...
          <a href="http://www.crea.ca/housing-market-stats/">Read more ›</a>
        </p>
      </div>
    </div>
  )
}

export default SideBar
